import { showGenericError, showErrorNotification } from "./Notifications";

export const executeBulkDelete = async ({ items, deleteAction, onSuccess, setLoading }) => {
  if (!items || items.length === 0) return;
  if (setLoading) setLoading(true);

  try {
    const deletionPromises = items.map((item) => deleteAction(item));
    const results = await Promise.allSettled(deletionPromises);
    const failedDeletions = results.filter(result => result.status === 'rejected');

    if (failedDeletions.length === items.length) {
      throw new Error("All deletions failed");
    } else if (failedDeletions.length > 0) {
      showErrorNotification(`${failedDeletions.length} items failed to delete due to an error.`);
    }

    if (onSuccess) onSuccess();
  } catch (error) {
    showGenericError();
    if (setLoading) setLoading(false); 
    throw error;
  }
};